import React, { useState, useEffect, useCallback } from "react";
import { message } from "antd";

import { select, remove } from "../actions/dimensionsAndType";
import { downloadFile } from "../../../components/util";
import { WrappedFormHability } from "./formHability";
import { QmDimensionTable } from "../components/qmTable";
import { ColumnProps, PaginationConfig, SorterResult } from "antd/lib/table";
import { IHability, IHabilityListResponse } from "./types";
import { ITableFilter, ITableSort, QmKeyObject } from "../components/types";
import { Utilitaries } from "../../../business";

const listName = "habilidades";
const REPORT_PARAMS = {
    accao: "lista",
    lista: listName,
    campos: "tipo_habilidade:400:Tipo de habilidade;designacao:400:Habilidade;",
    titulo: "Habilidades",
};

export function Hability() {
    const [dataSource, setDataSource] = useState<IHability[]>([]);
    const [loadingData, setLoadingData] = useState(true);

    const [showDeleteRecords, setShowDeleteRecords] = useState(false);
    const [filter, setFilter] = useState<ITableFilter>({
        pagination: {
            page: 1,
            perPage: 0,
        },
        filter: {},
    });

    const [editRow, setEditRow] = useState<IHability | null>(null);
    const [showModalNew, setShowModalNew] = useState(false);

    const getHability = useCallback(() => {
        setLoadingData(true);
        select({
            accao: "lista",
            lista: listName,
            pagina: 1,
            resultados_pagina: 0,
            mostra_lista_eliminados: showDeleteRecords,
        })
            .then((responses: IHabilityListResponse) => {
                const list: IHability[] = Utilitaries.toArray(responses.linha);
                const data = list.map((item) => {
                    return {
                        ...item,
                        designacao: typeof item.designacao === "object" ? "" : item.designacao,
                    };
                });

                setDataSource(data);
                setLoadingData(false);
            })
            .catch(() => {
                message.error("Ocorreu um erro ao carregar os tipos de requisitos.");
            });
    }, [showDeleteRecords]);

    useEffect(() => {
        getHability();
    }, [getHability]);

    async function onExportList(type: "pdf" | "xls") {
        const params = {
            ...REPORT_PARAMS,
            filter,
            saida: type,
            downloadInBrowser: true,
        };
        await downloadFile("gerelistas.php", params);
    }

    function toggleShowDelete(value: boolean) {
        setShowDeleteRecords(value);
    }

    function handleNew() {
        setShowModalNew(true);
    }

    function handleCloseNew(reload?: boolean) {
        if (reload) {
            getHability();
        }
        setShowModalNew(false);
    }

    function handleEdit(row: IHability) {
        setEditRow(row);
    }

    function handleCloseEdit(reload?: boolean) {
        if (reload) {
            getHability();
        }
        setEditRow(null);
    }

    function deleteRow(id: string) {
        remove({
            accao: "eliminar",
            lista: listName,
            chave1: id,
        }).then((sucess) => {
            if (sucess) {
                message.success("Linha eliminada com sucesso");
                getHability();
            } else {
                message.error("Ocorreu um erro");
            }
        });
    }

    function handleTableChange(
        _: PaginationConfig,
        filters: Partial<Record<keyof IHability, string[]>>,
        sorter: SorterResult<IHability>
    ) {
        const objFilter: QmKeyObject = {};

        if (filters) {
            Object.entries(filters).forEach(([key, val]) => {
                if (val && val[0]) objFilter[key] = val[0];
            });
        }

        let sortObj: ITableSort | null = null;
        if (sorter.columnKey && sorter.order) {
            sortObj = {
                sorterBy: sorter.columnKey,
                sorterOrder: sorter.order,
            };
        }

        setFilter((state) => ({
            ...state,
            pagination: {
                ...state.pagination,
                page: 1,
            },
            filter: objFilter,
            sorter: sortObj ?? undefined,
        }));
    }

    const columns: ColumnProps<IHability>[] = [
        {
            title: "Tipo de habilidade",
            dataIndex: "tipo_habilidade",
            width: "30%",
            ...QmDimensionTable.columnsSearch("tipo_habilidade"),
        },
        {
            title: "Habilidade",
            dataIndex: "designacao",
            width: "50%",
            ...QmDimensionTable.columnsSearch("designacao"),
        },
        {
            title: "Ações",
            dataIndex: "actions",
            width: "20%",
            render: (_, record) =>
                record._eliminado_ === "t" ? (
                    <QmDimensionTable.actions
                        deleteRow={() => deleteRow(record.id_habilidade)}
                        handleEdit={() => handleEdit(record)}
                    />
                ) : null,
        },
    ];

    return (
        <>
            <QmDimensionTable.list
                rowKey={(record) => record.id_tipo_habilidade}
                loading={loadingData}
                columns={columns}
                dataSource={dataSource}
                exportList={onExportList}
                toogleShowDeletedRecords={toggleShowDelete}
                handleNew={handleNew}
                onChange={handleTableChange}
            />

            {showModalNew && <WrappedFormHability onClose={handleCloseNew} />}
            {editRow && <WrappedFormHability record={editRow} onClose={handleCloseEdit} />}
        </>
    );
}
